var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostSaving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_563",
    "data-name": "Group 563",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.408,
    height: 78.692,
    viewBox: "0 0 65.408 78.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1501",
    "data-name": "Rectangle 1501",
    width: 65.408,
    height: 78.692,
    fill: "#ef4c1c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9325",
    "data-name": "Path 9325",
    d: "M34.9,25.795c11.871.022,21.735,8.506,21.9,22.037C56.947,59.807,46.929,69.6,34.861,69.6s-22.061-9.832-21.9-21.8c.181-13.54,10.094-21.995,21.937-22m-.045,41.061c10.282-.082,19.063-7.179,19.314-19.411.212-10.369-8.735-19.112-19.261-19.141-10.49-.028-19.461,8.656-19.309,19.087C15.774,59.56,24.5,66.734,34.852,66.856",
    transform: "translate(0.594 1.182)",
    fill: "#ef4c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9326",
    "data-name": "Path 9326",
    d: "M65.161,47.006c-.085,13.661-9.72,26.2-22.884,29.288A29.869,29.869,0,0,1,6.1,53.581a45.1,45.1,0,0,1-.7-5.825c-.1-1.154.429-1.818,1.264-1.861.858-.045,1.392.651,1.429,1.834A26.309,26.309,0,0,0,19.646,69.437c12.444,8.8,30.582,6.246,39.245-9.109a27.141,27.141,0,0,0,3.561-12.983,24.6,24.6,0,0,0-2.14-10.581c-.326-.732-.429-1.42.3-1.968a1.335,1.335,0,0,1,2.026.642A26.176,26.176,0,0,1,64.9,43.507c.135,1.161.176,2.332.259,3.5",
    transform: "translate(0.247 1.583)",
    fill: "#ef4c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9327",
    "data-name": "Path 9327",
    d: "M8.36,15.8v1.036q0,11.775,0,23.548c0,1.072-.441,1.63-1.285,1.621a1.176,1.176,0,0,1-1.3-1.14,10.088,10.088,0,0,1-.026-1.053q0-11.51,0-23.021V15.788L5.518,15.7c-.2.186-.4.369-.6.562-.853.845-1.689,1.709-2.56,2.534a1.311,1.311,0,0,1-1.953.072,1.281,1.281,0,0,1,.089-1.944,29.8,29.8,0,0,1,2.178-2.169c1.471-1.257,2.45-3.073,4.351-3.839,1.966.726,2.926,2.607,4.426,3.872a23.155,23.155,0,0,1,2.171,2.174,1.282,1.282,0,0,1-.589,2.206,1.974,1.974,0,0,1-1.386-.483c-.866-.739-1.631-1.6-2.442-2.4-.2-.2-.416-.381-.625-.57-.073.03-.145.062-.219.091",
    transform: "translate(0 0.5)",
    fill: "#ef4c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9328",
    "data-name": "Path 9328",
    d: "M35.606,4.874V6.687c0,1.963.008,3.926-.006,5.889-.006.919-.486,1.439-1.282,1.45A1.246,1.246,0,0,1,33,12.614c-.02-2.256-.008-4.512-.01-6.768V4.705a6.528,6.528,0,0,0-.654.477c-.874.865-1.732,1.749-2.612,2.608a1.365,1.365,0,0,1-2.019.183c-.619-.587-.583-1.341.147-2.076Q30.516,3.215,33.2.56a1.369,1.369,0,0,1,2.218.015q2.69,2.654,5.345,5.344a1.4,1.4,0,0,1,.142,2.031A1.341,1.341,0,0,1,38.9,7.8c-1.02-1-2.014-2.027-3.019-3.042l-.27.114",
    transform: "translate(1.25 0)",
    fill: "#ef4c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9329",
    "data-name": "Path 9329",
    d: "M34.815,18.145a29.71,29.71,0,0,1,22.17,10.843c.678.8.668,1.537.019,2.085s-1.365.446-2.05-.37a26.612,26.612,0,0,0-14.886-9.174c-1.672-.374-3.409-.457-5.117-.667-.2-.025-.41-.005-.615-.016-1.058-.052-1.719-.593-1.7-1.388.017-.815.676-1.31,1.742-1.314h.439",
    transform: "translate(1.495 0.831)",
    fill: "#ef4c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9330",
    "data-name": "Path 9330",
    d: "M32.838,60.444a1.969,1.969,0,0,1,0-.351c.2-1.154-.185-1.754-1.365-2.246a5.85,5.85,0,0,1-3.535-5.257,1.41,1.41,0,0,1,1.25-1.621c.784-.06,1.357.551,1.44,1.535a3.524,3.524,0,0,0,4.536,3.214,3.552,3.552,0,0,0-.816-6.965,6.181,6.181,0,0,1-5.746-3.666,5.765,5.765,0,0,1,.763-6.429,10.786,10.786,0,0,1,2.87-2.068c.413-.244.622-.413.609-.9-.029-.965-.025-1.934,0-2.9a1.346,1.346,0,1,1,2.681-.07c.046.964.038,1.934.014,2.9a.823.823,0,0,0,.64.956,6.142,6.142,0,0,1,4.247,5.409A1.473,1.473,0,0,1,39.207,43.8c-.769.07-1.363-.557-1.45-1.53a3.574,3.574,0,1,0-4.389,3.665c.619.149,1.277.129,1.909.238A6.194,6.194,0,0,1,36.4,58.095a1.118,1.118,0,0,0-.87,1.331c.047.847.033,1.7,0,2.549a1.331,1.331,0,0,1-1.413,1.446c-.775-.032-1.25-.576-1.277-1.483-.014-.5,0-1,0-1.494",
    transform: "translate(1.28 1.434)",
    fill: "#ef4c1c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostSaving);
export default __webpack_public_path__ + "static/media/cost_saving.0d01df9c1d6acf3096a2e151e036801d.svg";
export { ForwardRef as ReactComponent };